// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__170Pz","footer":"ModalUpdate_footer__3zFnW"};